import React, { useEffect, useRef, createElement } from 'react';
export const ContactPage = () => {
  const scriptLoadedRef = useRef(false);
  useEffect(() => {
    // Only run once
    if (scriptLoadedRef.current) return;
    scriptLoadedRef.current = true;
    // HoneyBook initialization function (from their embed code)
    const initHoneyBook = () => {
      const h = window as any;
      const b = document;
      const s = 'script';
      const n = 'https://widget.honeybook.com/assets_users_production/websiteplacements/placement-controller.min.js';
      const i = '696f8c6ff410b500085d55b6';
      h._HB_ = h._HB_ || {};
      h._HB_.pid = i;
      const t = b.createElement(s);
      t.type = 'text/javascript';
      t.async = true;
      t.src = n;
      const e = b.getElementsByTagName(s)[0];
      if (e && e.parentNode) {
        e.parentNode.insertBefore(t, e);
      }
    };
    // Small delay to ensure DOM is ready
    setTimeout(initHoneyBook, 100);
  }, []);
  return <div className="bg-white w-full min-h-screen" data-id="element-751">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-752">
        <div className="text-center mb-12" data-id="element-753">
          <h1 className="text-4xl md:text-5xl font-bold text-primary-500 leading-tight" data-id="element-754">
            Contact Us
          </h1>
          <p className="mt-4 text-lg text-gray-600" data-id="element-755">
            Get in touch with us for any questions or booking inquiries
          </p>
        </div>

        {/* HoneyBook Widget Container */}
        <div className="hb-p-696f8c6ff410b500085d55b6-1" data-id="element-756"></div>
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.honeybook.com/p.png?pid=696f8c6ff410b500085d55b6" alt="" data-id="element-757" />
      </div>
    </div>;
};